import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        first: String,
        second: String,
    };

    static targets = [
        'container',
    ];

    toggle(event) {
        event.preventDefault();

        if (this.containerTarget.classList.contains(this.firstValue)) {
            this.containerTarget.classList.remove(this.firstValue);
            this.containerTarget.classList.add(this.secondValue);
        } else {
            this.containerTarget.classList.remove(this.secondValue);
            this.containerTarget.classList.add(this.firstValue);
        }
    }
}
